import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export const ShoppingBagLink = styled("a")`
    border: 0;
    background: 0;
    position: relative;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    justify-content: center;
`

export const Label = styled("div")`
    position: absolute;
    justify-content: center;
    align-items: center;
    display: flex;
    width: 100%;
    height: 80%;
    top: 15%;
    color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.default.textColor};
    font-size: ${({theme}) => theme.uxfabric.component.badgeLabel.fontSize};
    font-weight: ${({theme}) => theme.uxfabric.component.badgeLabel.fontWeight};
    font-family: ${({theme}) =>
        `${theme.uxfabric.component.badgeLabel.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    line-height: ${({theme}) => theme.uxfabric.component.badgeLabel.lineHeight};
`
